import TableEntry from '../../TableEntry';
import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import radiatorIcon from '../../../../../../assets/icons/png/3x/icn-heizung@3x-schwarz.png';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import React from 'react';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';
import { useTranslation } from 'react-i18next';

const ExactMetering = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelExactMeteringTitle'),
        t('pageSummaryBasicServicesSectionLabelExactMeteringContent')
      ]}
      startElement={
        <Icon iconSrc={radiatorIcon} size={ICONSIZE.medium} alt="exact metering icon" />
      }
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default ExactMetering;
